// File: src/api/deleteUser.js

import client from './client';
import { getUserId, getAuthCode } from './authStorage';

/**
 * Delete a user (admin)
 * Send either target_user_id OR target_username
 * @param {{ target_user_id?: number, target_username?: string }} params
 */
export async function deleteUser(params = {}) {
  const payload = {
    user_id:   getUserId(),
    auth_code: getAuthCode(),
    target_user_id: params.target_user_id,
    target_username: params.target_username
  };

 const { data } = await client.post('/admin_delete_user.php', payload);

  if (data.status !== 200) {
    throw new Error(data.message || 'Failed to delete user');
  }

  return data;
}
